
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'KnowledgeAiReviewGate',
  props: {
    canEnable: {
      type: Boolean,
      default: false
    },
    settingsRoute: {
      type: String,
      default: ''
    }
  },
  computed: {
    body(): string {
      return this.canEnable
        ? "Knowledge is captured from AI code reviews. Turn it on to start collecting your team's suppressions, conventions, and context."
        : 'Knowledge is captured from AI code reviews. Ask a team admin to enable AI review.'
    }
  }
})
